import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mathy } from 'app/shared/utilities/shared.functions';
import { CustomerApi } from 'app/shared/api/customer.api';

@Component({
  selector: 'customer-tags',
  templateUrl: './customer-tags.component.html',
  styleUrls: ['./customer-tags.component.css']
})
export class CustomerTagsComponent implements OnInit {
  api = new CustomerApi(this.http);

  @Input() customerId:string;
  @Input() tags: CustomerTag[] = [];
  @Output() tagsChange = new EventEmitter<CustomerTag[]>();

  allTags: CustomerTag[];
  showAutocomplete:boolean = false;
  filteredTags: CustomerTag[];
  tagInput: string = '';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.api.getCustomerTags().subscribe({
      next:(tags:CustomerTag[]) => {
        this.allTags = tags;
        this.filteredTags = this.allTags.filter(tag =>  (!!this.tags && !this.tags.map(x => x.customerTagId).includes(tag.customerTagId)) || (!this.tags));
      }
    })
  }

  onTagInputChange(){
    if(!!this.tagInput){
      let s = this.tagInput.toLowerCase();
      let t = !!this.tags ? this.tags.map(x => x.customerTagId) : [];
      this.filteredTags = this.allTags.filter(tag => tag.name.toLowerCase().match(s) && !t.includes(tag.customerTagId))
    }
    else this.filteredTags = this.allTags
  }

  addTagToCustomer(tag:CustomerTag){
    console.log(tag)
    this.api.addTagToCustomer(this.customerId , tag.customerTagId).subscribe({
      complete:()=> {
        if(!this.tags){
          this.tags = [tag]
        }
        else this.tags.push(tag);
      this.filteredTags = this.allTags.filter(t => !this.tags.find(tag => tag.customerTagId === t.customerTagId));
      this.tagInput = '';
      this.showAutocomplete = false;
      }
    })
  }

  removeTagFromCustomer(tag:CustomerTag){
    this.api.removeTagFromCustomer(this.customerId, tag.customerTagId).subscribe({
      complete:() => {
        const index = this.tags.findIndex(t => t.customerTagId === tag.customerTagId);
      if (index !== -1) {
        this.tags.splice(index, 1);
      }
      this.filteredTags = this.allTags.filter(t => !this.tags.find(tag => tag.customerTagId === t.customerTagId));
      }
    })
  }

  highlightText(text: string): string {
    const searchQuery = this.tagInput;
    if (searchQuery) {
      const pattern = new RegExp(searchQuery, 'gi');
      return text.replace(pattern, `<span style="background-color:yellow;">${searchQuery}</span>`);
    } else {
      return '<span>' +text + '</span>';
    }
  }

  delayedHide(){
    setTimeout(()=> this.showAutocomplete = false, 200)
  }

  tagTextColor(hex: string) {
    if(hex){
      let hsl = Mathy.hexDecimalToHSL(Mathy.hexToHexDecimal(hex.replace('#', ''))) as { h: number, s: number, l: number };
      if (!!hsl) return hsl.l < .55 ? 'black' : 'white';
      return 'black';
    }
    return 'black'
  }

  refocus(){
    setTimeout(()=> document.getElementById('customerTagSearcher').focus(), 200);
  }
}

interface CustomerTag {
  color:string;
  customerTagId:string;
  name:string;
  sortOrder:number;
}